export const parseResponseCode = (response) => {
    var _a;
    const { code, body: { errors }, } = response;
    let result = 0;
    const firstErrorCode = (_a = errors.find((error) => error.code !== undefined)) === null || _a === void 0 ? void 0 : _a.code;
    if (firstErrorCode)
        result = Number(`${code}${firstErrorCode}`);
    return result;
};
